export default __webpack_public_path__ + "static/Honda-387fa7c1a042a728b8d787cf164a1a83.jpg";